import app from 'flarum/common/app';
app.initializers.add('abulrehman-youtube-button-common', () => {
  console.log('[abulrehman/flarum-youtube-button] Hello, forum and admin!');
});